module.exports = __webpack_public_path__ + "assets/promos_icon.2c4beefd.svg";